/* Maison Bosoni — la profondeur de l'image d'ouverture.
 *
 * Une image fixe est un décor ; une image qui répond au défilement devient un
 * lieu. Le principe est ancien et tient en une phrase : ce qui est loin bouge
 * moins vite que ce qui est près. On décale donc la photo un peu moins vite
 * que la page, et le texte posé dessus un peu plus vite — c'est cet écart, pas
 * l'amplitude, qui fabrique la sensation de profondeur.
 *
 * Trois précautions qui comptent plus que l'effet lui-même :
 *
 *   — ce thème ne fait pas défiler la fenêtre mais un conteneur interne, et
 *     les évènements de défilement d'un élément ne remontent pas. On écoute
 *     donc en phase de capture sur le document, ce qui attrape le défilement
 *     d'où qu'il vienne ;
 *   — on ne touche qu'à des transformations, jamais à la géométrie : le
 *     navigateur n'a alors rien à recalculer, juste à recomposer ;
 *   — et si la personne a demandé moins d'animations dans son système, on ne
 *     fait rien du tout. Le luxe, c'est aussi de ne pas s'imposer.
 */
(function () {
  'use strict';

  var moins = window.matchMedia('(prefers-reduced-motion: reduce)');
  // Sous ce seuil, la section change de disposition : l'image passe au-dessus
  // du texte au lieu de le porter. Un décalage de profondeur n'a alors plus
  // rien à décaler — pire, il ferait glisser la photo hors de son cadre et
  // s'effacer un texte posé sur fond ivoire. Le seuil est le même que celui
  // du media query de la section ; les deux doivent rester d'accord.
  var SEUIL_EMPILE = 760;
  var sections = [];
  var enAttente = false;
  var nettoye = false;

  function recenser() {
    sections = Array.prototype.slice.call(
      document.querySelectorAll('[data-mb-ouverture]')
    );
  }

  function placer() {
    enAttente = false;

    if (window.innerWidth <= SEUIL_EMPILE) {
      // On ne nettoie qu'une fois : au-delà, il n'y a plus rien à défaire, et
      // écrire un style à chaque image forcerait un recalcul pour rien.
      if (!nettoye) { nettoyer(); nettoye = true; }
      return;
    }
    nettoye = false;

    var hauteurVue = window.innerHeight || document.documentElement.clientHeight;

    for (var i = 0; i < sections.length; i++) {
      var section = sections[i];
      var cadre = section.getBoundingClientRect();

      // Hors de l'écran : rien à calculer. Sur une page longue, c'est le cas
      // la plupart du temps.
      if (cadre.bottom <= 0 || cadre.top >= hauteurVue) continue;

      var media = section.querySelector('.mb-ouverture__media');
      var corps = section.querySelector('.mb-ouverture__corps');

      // Avancée de 0 (section en haut de l'écran) à 1 (entièrement sortie).
      var avance = -cadre.top / Math.max(cadre.height, 1);
      if (avance < 0) avance = 0;
      if (avance > 1) avance = 1;

      if (media) {
        // 6 % de la hauteur du média, qui déborde de 7 % : la photo ne
        // découvre jamais son bord, quelle que soit la hauteur d'écran.
        media.style.transform = 'translate3d(0,' + (avance * 6).toFixed(3) + '%,0)';
      }
      if (corps) {
        // Le texte part plus vite et s'efface : on quitte la scène au lieu
        // de la faire défiler.
        corps.style.transform = 'translate3d(0,' + (avance * -22).toFixed(3) + '%,0)';
        corps.style.opacity = Math.max(0, 1 - avance * 1.35).toFixed(3);
      }
    }
  }

  function demander() {
    if (enAttente) return;
    enAttente = true;
    requestAnimationFrame(placer);
  }

  function nettoyer() {
    for (var i = 0; i < sections.length; i++) {
      var media = sections[i].querySelector('.mb-ouverture__media');
      var corps = sections[i].querySelector('.mb-ouverture__corps');
      if (media) media.style.transform = '';
      if (corps) { corps.style.transform = ''; corps.style.opacity = ''; }
    }
  }

  function demarrer() {
    recenser();
    if (!sections.length) return;
    if (moins.matches) { nettoyer(); nettoye = true; return; }
    nettoye = false;
    placer();
  }

  document.addEventListener('scroll', demander, { capture: true, passive: true });
  window.addEventListener('resize', demander, { passive: true });

  // Le réglage système peut changer en cours de visite.
  if (moins.addEventListener) {
    moins.addEventListener('change', function () {
      if (moins.matches) nettoyer(); else placer();
    });
  }

  // L'éditeur de thème recharge une section sans recharger la page.
  document.addEventListener('shopify:section:load', demarrer);
  document.addEventListener('shopify:section:unload', demarrer);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
